import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { media } from '../ui/common';
import { colors } from '../../../ui/common';

export const Section = styled.section`
  padding: 60px 0 100px;
  overflow: hidden;
`;
export const Wrap = styled.div`
  width: 100vw;
  overflow: auto;
`;
export const List = styled.div`
  display: flex;
  overflow: auto;
  padding: 96px 0 48px;
  ${media.medium`
    margin: 0 -15px;
  `}
`;
export const Block = styled.div`
  padding: 10px;
  box-sizing: border-box;
  ${media.tablet`
    padding: 15px;
  `}
  ${media.medium`
    flex: 1 0 0;  
  `}
`;
export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.07);
  border-radius: 6px;
  color: ${colors.color05};
  padding: 20px 20px 0;
  box-sizing: border-box;
  text-align: center;
  width: 282px;
  ${media.medium`
    width: 100%;
  `}
  ${media.medium`
    padding: 20px 40px 0;
  `};
`;
export const Cell = styled.div`
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(3, 102, 99, 0.1);
  &:nth-child(2) {
    h4 {
      font-size: 16px;
    }
    p {
      margin-bottom: 8px;
    }
  }
  &:last-of-type {
    border-bottom: none;
  }
  svg {
    margin: 16px 0 0;
  }
`;
export const Title = styled.h4`
  font-weight: 600;
  font-size: 14px;
  margin: 0 0 16px;
`;
export const Value = styled.p`
  font-size: 14px;
  color: ${colors.color01};
  opacity: 0.8;
  margin: 0;
  line-height: 1.7;
`;
export const ImageWrap = styled.div`
  min-height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Image = styled(GatsbyImage)`
  width: 100px;
  margin: 16px auto 0;
  ${media.medium`
    width: 100px;
  `}
`;
